import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ColorSF2 from '../../styles/common/ColorSF2';

const Block = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  background-color: ${ColorSF2.white};
`;

/**
 * 表に表示するデータがない場合やカスタムメッセージを表示する関数コンポーネント。
 * @param {string} messageId - 表示するメッセージのID
 * @returns {ReactElement}
 * @example
 * <MessagePlaceholder messageId="timeLine.nodata" />
 */
const MessagePlaceholder = ({ messageId }) => (
  <Block>
    <div>
      <FormattedMessage id={messageId} />
    </div>
  </Block>
);

MessagePlaceholder.propTypes = {
  messageId: PropTypes.string,
};

MessagePlaceholder.defaultProps = {
  messageId: 'timeLine.nodata',
};

export default MessagePlaceholder;
